import helper from '@/api/helper';
import config from '@/configs/config';

const API_ENDPOINT = `${config.API_ENDPOINT}/externalApi-activityCommand`;

const DEFAULT_QUERY = {
  env: process.env.REACT_APP_MODE,
};

export const getActivities = () => helper.get({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'getActivities',
  },
});

export const mgmShareLink = ({
  campaignName,
  token,
}) => helper.post({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
  },
  body: {
    campaignName,
    command: 'mgmShareLink',
    token,
  },
});
